import { createContext } from 'react'

import { ISettings } from '../types/settings.interface'

export const SettingsContext = createContext<ISettings>({} as ISettings)
